<template>
    <div>
        <b-form @submit="OnSubmitForm">
            <div class="content">
                <div class="d-flex align-items-center mb-3">
                    <b-button variant="light" @click="goback()" class="mr-2 rounded-circle">
                        <b-icon icon="arrow-left"></b-icon>
                    </b-button>
                    <h4 class="mb-0 font-weight-bold">ແກ້ໄຂຂໍ້ມູນ</h4>
                </div>
                <b-row align-h="center">
                    <b-col class="col-md-6">
                        <b-card header="ບັນທຶກຂໍ້ມູນ" header-tag="header">
                            <b-row v-for="(item,index) in data.frm" :key="item.id">
                                <b-col>
    
                                    <div class="text-left" v-if="item.fieldtype === 'text'">
                                        <b-form-group :id="'input-group-'+index" :label="item.text_lao" :label-for="item.name" description="">
                                            <b-form-input :disabled="item.name===data.pkey" id="name" type="text" v-model="data.model[item.name]" placeholder="" required></b-form-input>
                                        </b-form-group>
    
                                    </div>
    
                                    <div class="text-left" v-if="item.fieldtype === 'date'">
                                        <b-form-group :id="'input-group-' + item.id" :label="item.text_lao" :label-for="item.name" description="">
                                            <b-form-datepicker :id="item.name" :date-format-options="{
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            }" v-model="data.model[item.name]" locale="lao"></b-form-datepicker>
                                        </b-form-group>
                                    </div>
    
                                    <div class="text-left" v-if="item.fieldtype === 'select'">
    
                                        <b-form-group id="input-group-1" :label="item.text_lao" description="">
                                            <b-form-select v-model="data.model[item.name]" :options="item.choices" required></b-form-select>
    
                                        </b-form-group>
    
                                    </div>
    
                                </b-col>
                            </b-row>
    
                            <template #footer>
                    <b-row>
                      <b-col lg="12" class="pb-2">
                        <b-button block variant="primary" size="lg" type="submit"
                          >ບັນທຶກ</b-button
                        >
                      </b-col>
                    </b-row>
</template>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-form>
   
  </div>
</template>

<script>
//import Vue from "vue";
import axios from "axios";
//import VueFormGenerator from "vue-form-generator";
//import "vue-form-generator/dist/vfg.css";

//Vue.use(VueFormGenerator);

export default {
    name: "FormGenarate",
    data() {
        return {
            form: "",
            data: [],
            select1: [],
            select2: [],
            select3: [],
            select4: [],
            select5: [],
            select6: [],
            options:[],
            user:[]
        };
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },

        OnSubmitForm(event) {
            event.preventDefault();

            let rp_data = null;
            let postsdata = {
                table: this.data.frm[0].type,
                rows: this.data.model,
                pkey: this.data.pkey,
                wharevalue: this.$route.params.val

            };
            axios
                .post(
                    this.$store.getters.getBaseUrl + "/jsonUpdate",
                    postsdata,{
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        // alert(rp_data.desc);

                        // this.$bvModal
                        //     .msgBoxOk(rp_data.desc, {
                        //         title: "ຂໍ້ວາມາແຈ້ງ.....",
                        //         size: "sm",
                        //         buttonSize: "sm",
                        //         okVariant: "success",
                        //         headerClass: "p-2 border-bottom-0",
                        //         footerClass: "p-2 border-top-0",
                        //         centered: true,
                        //     })
                        this.$router.go(-1);

                    } else {
                        //alert(rp_data.desc);
                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "Confirmation",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                    }
                });
        },
    },
    mounted() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        axios
            .get(this.$store.getters.getBaseUrl + "/getJsonUpdateForm/" + this.$route.params.menuid + '/' + this.$route.params.val,
            {
                headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.data = response.data;
                // let rp= response.data;

                //  console.log(  JSON.parse(response.data))
            })
            .catch((e) => {
                this.errors.push(e);
            });
    },
    created() {},
};
</script>

<style scoped>
.content {
    padding-top: 20px;
}
</style>